import _ from 'lodash';
import { Dispatch, GetState } from '../../../redux/redux.types';
import { uploadFileInternal } from '../../file-manager/redux/file-manager.actions';
import { getFailedUploadOperationMap } from './upload-operations/upload-operations.selectors';

export const OPERATION_GROUPS_ACTION_NAMES = {
  CLOSE_GROUP: 'OPERATION_GROUPS_ACTION_NAMES__CLOSE_GROUP',
};

// TODO: get rid of operationIds param because this has no sense for some Groups (Multiple Download)
export const closeOperationGroup = (
  groupId: string,
  operationIds: string[],
) => ({
  type: OPERATION_GROUPS_ACTION_NAMES.CLOSE_GROUP,
  payload: {
    groupId,
    operationIds,
  },
});

export function cancelFilesUploadGroup() {
  return (/* dispatch: Dispatch, getState: GetState*/) => {
    // TODO: Cancel uploads
    /* return dispatch({
      types: [
        OPERATION_GROUPS_ACTION_NAMES.GET_START,
        OPERATION_GROUPS_ACTION_NAMES.GET_SUCCESS,
        OPERATION_GROUPS_ACTION_NAMES.GET_ERROR
      ],
      callApi: () => getSomething()
    });*/
  };
}

export function cancelFileUpload(clientId) {
  return (/* dispatch: Dispatch, getState: GetState*/) => {
    // TODO: Cancel uploads
  };
}

export function retryUploadOperations(operationIds: string[]) {
  return (dispatch: Dispatch, getState: GetState) => {
    _(getFailedUploadOperationMap(getState()))
      .pick(operationIds)
      .values()
      .forEach((uploadOperation) => {
        uploadFileInternal(
          uploadOperation.path,
          uploadOperation.clientId,
          uploadOperation.file,
        )(dispatch, getState);
      });
  };
}
